import * as React from 'react';
import { styled } from '@linaria/react';

import Demo, { DemoSliderControl } from '@/components/Demo';
import ClientOnlySnippet from '@/components/CodeSnippet/ClientOnlySnippet';

function BasicBlur({}) {
  return (
    <Demo
      initialValues={{
        radius: 16,
      }}
      controlPosition="bottom"
      outputWrapper={null}
      customGrid={{
        gridTemplateColumns: '1fr',
      }}
      controls={[
        <DemoSliderControl
          key="radius"
          id="radius"
          label="Blur radius"
          min={0}
          max={16}
          previewRenderer={(val) => `${val}px`}
          wrapperStyle={{
            maxWidth: 400,
            width: '100%',
            marginInline: 'auto',
          }}
        />,
      ]}
    >
      {({ radius }) => {
        return (
          <>
            <Wrapper>
              <Josh
                alt="My 3D mascot smiling with his tongue out. It’s very blurry, but dragging the slider makes it clearer"
                src="/images/josh-originals/josh-tongue-dark.png"
                loading="lazy"
                style={{
                  filter: `blur(${radius}px)`,
                }}
              />
              <CodeWrapper>
                <ClientOnlySnippet
                  lockedToColorMode="dark"
                  omitCopyButton
                  lang="css"
                  code={`\
.josh-mascot {
  filter: blur(${radius}px);
}\
`}
                />
              </CodeWrapper>
            </Wrapper>
          </>
        );
      }}
    </Demo>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  border: 1px solid var(--color-content-outline);
  border-radius: 8px;
`;

const Josh = styled.img`
  width: calc(275px * 0.5);
  height: calc(464px * 0.5);
  margin-bottom: -98px;
`;

const CodeWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 300px;
  min-height: 8rem;
  border: 1px solid var(--color-gray-200);
  background: var(--color-background);
  align-self: center;
  border-radius: 4px;
`;

export default BasicBlur;
